import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_API_KEY = 'scheduler/category';

export function useMeetingCategoriesQuery({
	userId,
	enabled = true,
	impersonationContext,
}: {
	userId?: string;
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
}) {
	const userSession = useUserSession();

	return useQuery({
		queryFn: () =>
			userSession.webServiceHelper.callAsync<Api.IPagedCollection<Api.IMeetingCategory>>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					queryParams: {
						forUserId: userId,
						pageSize: 100,
					},
					urlPath: BASE_API_KEY,
				}),
				'GET'
			),
		queryKey: [BASE_API_KEY, impersonationContext, userId],
		enabled,
		meta: {
			toastErrorMessage: 'Failed to load meeting categories',
			errorLogging: { category: 'Scheduler', action: 'MeetingCategoriesQuery-Error' },
		},
	});
}

export const invalidateMeetingCategoriesQuery = () => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_API_KEY] });
};
